import { render, staticRenderFns } from "./contractRedact.vue?vue&type=template&id=4f049ed3&scoped=true&"
import script from "./contractRedact.vue?vue&type=script&lang=js&"
export * from "./contractRedact.vue?vue&type=script&lang=js&"
import style0 from "./contractRedact.vue?vue&type=style&index=0&lang=less&"
import style1 from "./contractRedact.vue?vue&type=style&index=1&id=4f049ed3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f049ed3",
  null
  
)

export default component.exports